/* ÖDER first-party interaction events. Never send contact form values or URL queries. */
(function () {
  'use strict';
  if (window.oderMeasurementLoaded) return;
  window.oderMeasurementLoaded = true;
  function allowed() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    return !!(p && p.analyticsProcessingAllowed && p.analyticsProcessingAllowed());
  }
  function emit(name, extra) {
    if (!allowed()) return;
    var a = window.Shopify && window.Shopify.analytics;
    if (!a || typeof a.publish !== 'function') return;
    var data = Object.assign({ page_path: location.pathname, language: document.documentElement.lang }, extra || {});
    try { Promise.resolve(a.publish(name, data)).catch(function () {}); } catch (_) {}
  }
  if (window.Shopify && window.Shopify.loadFeatures && !window.Shopify.customerPrivacy) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], function () {});
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href]');
    if (link) {
      var href = link.getAttribute('href') || '';
      var method = /^(https:\/\/wa\.me\/|https:\/\/api\.whatsapp\.com\/)/.test(href) ? 'whatsapp'
        : /^tel:/.test(href) ? 'phone' : /^mailto:/.test(href) ? 'email' : '';
      if (method) emit('oder_contact_click', {contact_method:method});
    }
    var button = e.target.closest && e.target.closest('#oder-ges-hesapla');
    if (button) {
      var bill = document.getElementById('oder-ges-fatura');
      if (bill && Number(bill.value) > 0) emit('oder_calculator_used', {calculator:'ges'});
    }
  });
  document.addEventListener('submit', function (e) {
    if (e.target.id === 'OderSystemPlannerForm' && e.target.checkValidity()) {
      emit('oder_quote_submit', {form_id:'system_planner'});
    }
  });
  function success() {
    var marker = document.querySelector('[data-oder-quote-success]');
    if (!marker || !allowed()) return;
    try {
      if (sessionStorage.getItem('oder_quote_success_seen') === '1') return;
      sessionStorage.setItem('oder_quote_success_seen', '1');
    } catch (_) {}
    emit('oder_quote_success', {form_id:'system_planner'});
  }
  success();
  document.addEventListener('visitorConsentCollected', success);
})();
